{
	"title": "中澤 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "全螢幕",
		"achievements": "成就",
		"reset": "重置",
		"language": "語言"
	},
	"achievements": {
		"title": "成就",
		"noAchievements": "還沒有獲得任何成就。繼續點擊！",
		"unlocked": "解鎖成就：{{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 新手兔子",
		"carrotSnatcher": "🥕 蔬菜大盜",
		"bunnyBerserker": "😡 狂暴兔子",
		"hopPunk": "🎸 龐克兔子",
		"bunnyNinja": "🥷 無聲致命毛球",
		"expert": "🌟 跳躍專家",
		"master": "👑 胡蘿蔔之王",
		"carrotpocalypse": "🥕 菜園毀滅者",
		"bunnyOverlord": "😈 兔子洞霸主",
		"chaosHare": "🌪️ 混沌特工",
		"carrotCultist": "⛪ 胡蘿蔔教大祭司",
		"bunnyberryPie": "🥧 幻覺派大師",
		"rabbitHole": "🕳️ 量子隧道挖掘機",
		"moonRabbit": "🌙 月兔搗藥",
		"bunnyDoom": "💀 兔子末日使者",
		"carrotNuke": "☢️ 核胡蘿蔔持有者",
		"bunnyMatrix": "🤖 兔子矩陣故障",
		"cosmicHare": "🌌 宇宙之兔覺醒",
		"warrenSingularity": "🕳️ 兔子洞奇點達成",
		"eternalBunny": "♾️ 永恆之兔"
	},
	"messages": {
		"prophecy": "古老的點擊預言開始展開...",
		"cosmic": "宇宙點擊者對你的進展感到驕傲！",
		"astral": "點擊聲迴盪在星界中...",
		"speaking": "等等...你聽到了嗎？點擊在跟我說話...",
		"ancient": "你的點擊與古老力量共鳴！",
		"sages": "點擊賢者低語著你的潛力...",
		"demons": "看哪！點擊惡魔從沉睡中甦醒！",
		"veil": "你的點擊穿透了現實的面紗！",
		"spirits": "點擊精靈隨著你的節奏起舞...",
		"council": "偉大的點擊議會注意到了你的奉獻",
		"primordial": "你的點擊喚醒了原始力量！",
		"void": "點擊虛空回望著你...",
		"runes": "古老的點擊符文隨著你的力量發光！",
		"beast": "三三三 - 點擊獸的數字",
		"prophets": "點擊先知歌頌你的到來！",
		"dimensions": "你的點擊迴盪在維度之間...",
		"portal": "你的點擊打開了通往點擊維度的傳送門！",
		"sacrifice": "古老的點擊之神要求更多祭品",
		"jackpot": "頭獎！點擊賭場歡迎它的最新冠軍！",
		"unmatched": "你的點擊力量無人能及！",
		"reality": "現實本身臣服於你的點擊意志！",
		"quartet": "點擊四重奏的預言實現了",
		"elite": "你已成為精英點擊大師",
		"power": "你的點擊力量超過1500！",
		"devils": "點擊惡魔向你的力量鞠躬",
		"lucky": "幸運點擊流淌在你的血液中",
		"dynasty": "點擊王朝承認你的至高無上",
		"twoThousand": "兩千次純粹力量的點擊！",
		"quartet2": "點擊四重奏的預言實現了",
		"transcend": "你的點擊超越凡人理解",
		"constellation": "點擊星座為你的榮耀而排列",
		"destiny": "三千次命運的點擊",
		"triforce": "三重點擊力量覺醒！",
		"fortune": "命運眷顧堅持不懈的點擊者",
		"newDimensions": "你的點擊力量達到新的維度",
		"threshold": "站在點擊神性的門檻上",
		"ultimate": "五千次終極力量的點擊！",
		"force": "五指點擊力量任你指揮",
		"underworld": "點擊冥界加冕你為統治者",
		"maxJackpot": "達到最大點擊頭獎",
		"infinite": "無限點擊力量！",
		"godhood": "你已晉升為點擊之神",
		"burrow": "你比任何兔子都挖得更深...",
		"warren": "偉大的兔子洞認可你的存在...",
		"thump": "你每次跺腳都讓大地震動！",
		"darkWarren": "黑暗兔子洞為你敞開大門...",
		"ears": "你的耳朵越來越長...現在你能聽到一切...",
		"carrotThrone": "胡蘿蔔王座在你面前顯現...",
		"onesAlignment": "所有的一都對齊了 - 兔子洞頻率共振！",
		"moonSummon": "月兔隔著虛空聽到了你的呼喚...",
		"edgeOfForever": "你站在永恆的邊緣...耳朵微微顫動...",
		"beyondTheVeil": "面紗之外，所有兔子洞合為一體...",
		"sequence": "1-2-3-4-5...神聖的跳躍序列完成了！",
		"hyperElite": "超級精英兔子狀態解鎖 🐇🐇🐇",
		"eventHorizon": "越過宇宙兔子洞的事件視界...",
		"matrixAwakens": "兔子洞矩陣出現故障...你看到了現實背後的胡蘿蔔",
		"luckyForever": "每一隻爪子，每一次跳躍，每一次顫動...永遠被祝福",
		"twentyK": "兩萬。你不再是一隻兔子。你就是那隻兔子。",
		"singularity": "兔子奇點。所有兔子都是你。你就是所有兔子。",
		"tripleAscension": "宇宙之兔的三重升天！",
		"ultimateAnswer": "42,000 - 終極答案從一開始就是胡蘿蔔",
		"eternity": "♾️ 永恆的兔子洞沒有盡頭。你也是。♾️"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} 獎勵分數！",
		"clickStreak": "🔥 {{count}}連擊！",
		"fire": "🔥 火焰力量啟動！"
	},
	"table": {
		"achievement": "成就",
		"progress": "進度"
	},
	"reset": {
		"confirm": "確定要重置所有進度嗎？此操作無法撤消。"
	}
}
